import { Controller } from 'react-hook-form'
import {
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    HStack,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
} from '@chakra-ui/react'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

export function ResultInput() {
    const { zodForm, isFormDisabled, isResultRequired } = useMatchEditorFormContext()

    return (
        isResultRequired && (
            <FormControl
                maxW="50%"
                mb={8}
                isInvalid={!!zodForm.formState.errors.team1_score || !!zodForm.formState.errors.team2_score}
                isRequired
                isDisabled={isFormDisabled}>
                <FormLabel>Result</FormLabel>
                <HStack>
                    <Controller
                        rules={{ deps: ['team2_score'] }}
                        control={zodForm.control}
                        name="team1_score"
                        render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                            <FormControl>
                                <NumberInput
                                    min={0}
                                    defaultValue={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    isInvalid={!!error || !!zodForm.formState.errors.team2_score}
                                    isRequired>
                                    <NumberInputField ref={ref} name={name} />
                                    <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper>
                                </NumberInput>
                                <FormHelperText>Home</FormHelperText>
                            </FormControl>
                        )}
                    />
                    <Controller
                        rules={{ deps: ['team1_score'] }}
                        control={zodForm.control}
                        name="team2_score"
                        render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                            <FormControl>
                                <NumberInput
                                    min={0}
                                    defaultValue={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    value={value}
                                    isInvalid={!!error || !!zodForm.formState.errors.team1_score}
                                    isRequired>
                                    <NumberInputField ref={ref} name={name} />
                                    <NumberInputStepper>
                                        <NumberIncrementStepper />
                                        <NumberDecrementStepper />
                                    </NumberInputStepper>
                                </NumberInput>
                                <FormHelperText>Away</FormHelperText>
                            </FormControl>
                        )}
                    />
                </HStack>
                <FormErrorMessage>
                    {zodForm.formState.errors.team1_score?.message || zodForm.formState.errors.team2_score?.message}
                </FormErrorMessage>
            </FormControl>
        )
    )
}
